// Instance apiClient — httpOnly cookie auth (no Bearer token).
// BFF apps-platform-backend usa JWT en cookie `session` (set por POST /auth/login).
// `credentials: 'include'` del @crm/api-client factory asegura browser envía
// cookies cross-origin (requiere CORS allow_credentials=true + Access-Control-
// Allow-Origin exacto no wildcard).
import { createApiClient } from '@crm/api-client'

export const apiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? '',
})
